import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container p-0" }
const _hoisted_2 = { class: "input-group has-validation" }
const _hoisted_3 = ["id", "name", "required", "multiple", "aria-describedby", "aria-invalid", "aria-busy", "disabled"]
const _hoisted_4 = {
  key: 0,
  value: "",
  selected: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "input-group-append"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        ref: "selectField",
        id: _ctx.ids.input,
        name: _ctx.element.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.elementChanged && _ctx.elementChanged(...args))),
        class: "form-select",
        required: _ctx.element.required,
        multiple: _ctx.element.multiple,
        "aria-describedby": _ctx.describedBy,
        "aria-invalid": _ctx.ariaInvalid,
        "aria-busy": _ctx.isLoading ? 'true' : undefined,
        disabled: _ctx.hidden
      }, [
        (!_ctx.element.multiple)
          ? (_openBlock(), _createElementBlock("option", _hoisted_4, _toDisplayString(_ctx.getTextFor(_ctx.element.placeholder, _ctx.lang)), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(_ctx.getTextFor(option.text, _ctx.lang)), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_3), [
        [_vModelSelect, _ctx.formData]
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "input-group-text" }, [
              _createElementVNode("div", {
                class: "spinner-border spinner-border-sm",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
              ])
            ], -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "invalid-feedback",
      id: _ctx.ids.error,
      style: _normalizeStyle(_ctx.invalidStyle)
    }, _toDisplayString(_ctx.getTextFor(_ctx.element.invalid, _ctx.lang)), 13, _hoisted_7),
    (_ctx.heeftUitleg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.ids.help,
          class: "form-text"
        }, _toDisplayString(_ctx.getTextFor(_ctx.element.explanation, _ctx.lang)), 9, _hoisted_8))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, !_ctx.hidden]
  ])
}